<dff-side [observable]="vm$">
    @if (vm$ | async; as vm) {
        <form [formGroup]="vm.formGroup" novalidate>
            <div>
                <div>
                    <mat-form-field>
                        <mat-label>Forbrugernr.</mat-label>
                        <input matInput placeholder="Forbrugernr." formControlName="ejendomnr" />
                    </mat-form-field>
                </div>
                <div><br /></div>
                <div>
                    <mat-label> {{ vm.formGroup.value.navn }}{{ vm.formGroup.value.navn2 }} </mat-label>
                </div>
                <div>
                    <mat-label>
                        {{ vm.formGroup.value.vejnavn }} {{ vm.formGroup.value.husnr }} {{ vm.formGroup.value.litra }}
                        {{ vm.formGroup.value.litra2 }}
                    </mat-label>
                </div>
                <div>
                    <mat-label> {{ vm.formGroup.value.postnr }} {{ vm.formGroup.value.bynavn }} </mat-label>
                </div>
                <div>
                    <br />
                    <div>
                        <mat-form-field>
                            <mat-label>Mobilnummer (sæt komma ved flere mobilnumre)</mat-label>
                            <input
                                id="qa-stamoplysninger-telephoneNumber-input"
                                type="tel"
                                matInput
                                placeholder="Mobilnummer (sæt komma ved flere mobilnumre)"
                                formControlName="telefonnr"
                                aria-label="Mobilnummer"
                                [attr.aria-disabled]="vm.formGroup.controls.telefonnr.disabled"
                            />
                            @if (vm.formGroup.get("telefonnr").errors) {
                                <mat-error>Indtast en gyldig telefonnr </mat-error>
                            }
                        </mat-form-field>
                        @if (vm.formGroup.controls.telefonnr.disabled) {
                            <button
                                id="qa-stamoplysninger-telephoneNumber-edit-button"
                                mat-icon-button
                                (click)="vm.formGroup.controls.telefonnr.enable(); addFocus('qa-stamoplysninger-telephoneNumber-input')"
                                aria-label="Rediger telefonnummer"
                                aria-controls="qa-stamoplysninger-telephoneNumber-input"
                                role="button"
                                type="button"
                            >
                                <mat-icon svgIcon="mine-oplysninger-edit"></mat-icon>
                            </button>
                        }
                        @if (!vm.formGroup.controls.telefonnr.disabled) {
                            <span>
                                <button
                                    id="qa-stamoplysninger-telephoneNumber-check-button"
                                    mat-icon-button
                                    (click)="redigerTelefonnr(vm.formGroup, vm.formGroup.controls.telefonnr.value)"
                                    aria-label="Gem telefonnummer"
                                >
                                    <mat-icon svgIcon="mine-oplysninger-check"></mat-icon>
                                </button>
                                <button
                                    id="annullerTlf"
                                    mat-icon-button
                                    (click)="annullerRedigerTelefonnr(vm.formGroup, vm.installationsoplysninger.telefonnr)"
                                    aria-label="Annuller redigering af telefonnummer"
                                >
                                    <mat-icon svgIcon="mine-oplysninger-close"></mat-icon>
                                </button>
                            </span>
                        }
                    </div>
                </div>
                <div>
                    <br />
                    <div>
                        <mat-form-field>
                            <mat-label>E-mail (sæt komma ved flere e-mails)</mat-label>
                            <input
                                id="beboeremailFelt"
                                type="email"
                                matInput
                                placeholder="E-mail (sæt komma ved flere e-mails)"
                                formControlName="beboeremail"
                                aria-label="E-mail"
                                [attr.aria-disabled]="vm.formGroup.controls.beboeremail.disabled"
                            />
                            @if (vm.formGroup.get("beboeremail").errors) {
                                <mat-error>Indtast en gyldig e-mail </mat-error>
                            }
                        </mat-form-field>
                        @if (vm.formGroup.controls.beboeremail.disabled) {
                            <button
                                id="retBeboeremail"
                                mat-icon-button
                                (click)="vm.formGroup.controls.beboeremail.enable(); addFocus('beboeremailFelt')"
                                aria-label="Rediger email"
                                aria-controls="beboeremailFelt"
                            >
                                <mat-icon svgIcon="mine-oplysninger-edit"></mat-icon>
                            </button>
                        }
                        @if (!vm.formGroup.controls.beboeremail.disabled) {
                            <span>
                                <button
                                    id="opdaterBeboeremail"
                                    mat-icon-button
                                    (click)="redigerBeboeremail(vm.formGroup, vm.formGroup.controls.beboeremail.value)"
                                    aria-label="Gem email"
                                >
                                    <mat-icon svgIcon="mine-oplysninger-check"></mat-icon>
                                </button>
                                <button
                                    id="annullerBeboeremail"
                                    mat-icon-button
                                    (click)="annullerRedigerBeboeremail(vm.formGroup, vm.installationsoplysninger.beboeremail)"
                                    aria-label="Annuller redigering af email"
                                >
                                    <mat-icon svgIcon="mine-oplysninger-close"></mat-icon>
                                </button>
                            </span>
                        }
                    </div>
                </div>
            </div>
        </form>
    }
</dff-side>
